<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button type="button" variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
          </b-col>
        </b-row>
        <b-form @submit.prevent="addItem">
          <b-row>
            <b-col>
              <b-alert variant="danger" :show="errors">
                Er ging iets mis...
                <ul class="mt-3">
                  <li v-for="error in errors">{{error.toString()}}</li>
                </ul>
              </b-alert>
              <b-card>
                <template #header>
                    <div class="pull-left mt-2 mb-2"><strong>Nieuw bedrijf</strong></div>
                </template>
                <b-row>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Basisgegevens</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" md="8">
                        <b-form-group label="Naam">
                          <b-form-input type="text" required v-model="item.name"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Maximale bestelwaarde">
                          <b-form-input type="number" required v-model="item.max_order_amount" autocomplete="off">></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-form-group label="Moederbedrijf">
                          <b-form-select :options="companyOptions" v-model="item.parent_company_id" autocomplete="off">></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col cols="12" md="8">
                        <h5>Adresgegevens</h5>
                        <hr>
                      </b-col>
                      </b-row>
                    <b-row>
                      <b-col cols="12" md="8">
                        <b-form-group label="Adres">
                          <b-form-input type="text" required v-model="item.address" autocomplete="off">></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="3">
                        <b-form-group label="Postcode">
                          <b-form-input type="text" required v-model="item.postal_code" autocomplete="off">></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="5">
                        <b-form-group label="Plaats">
                          <b-form-input type="text" required v-model="item.city" autocomplete="off">></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group label="Land">
                          <b-form-select :options="countryOptions" required v-model="item.country_code" autocomplete="off">></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>

                    <b-row>
                      <b-col cols="12" md="8">
                        <b-form-group label="Petty cash">
                          <b-form-checkbox v-model="item.has_recurring_orders" name="transportOnDemand" :value="true" switch
                                           :disabled="!editable">
                          <span
                            v-if="item.has_recurring_orders">Ja, heeft <strong>wel</strong> herhaalde leveringen</span>
                            <span v-else>Nee, heeft <strong>geen</strong> herhaalde leveringen</span>
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="10" md="6">
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            <b-col cols="12" v-can="'bedrijven aanpassen'">
              <b-card>
                <b-button type="submit" variant="primary" :disabled="buttonDisabled">Bedrijf toevoegen</b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import { getData, addData } from '../../api';

export default {
  name: 'company-create',
  data() {
    return {
      companyOptions: [],
      countryOptions: [],
      buttonDisabled: false,
      item: {
        name: null,
        address: null,
        postal_code: null,
        city: null,
        country_code: null,
        max_order_amount: 0,
        parent_company_id: null,
        has_recurring_orders: false,
      },
      errors: null,
    }
  },
  methods: {
    async getCompanyOptions() {
      const options = await getData('companies/options').then(response => response.data);
      this.companyOptions = options.data;
      this.companyOptions.unshift({ text: "Geen moederbedrijf", value: null });
    },
    async getCountries() {
      const countries = await getData('countries').then(response => response.data);
      this.countryOptions = countries.data;
    },
    async addItem() {
      this.errors = null;
      this.buttonDisabled = true;
      const request = await addData('companies', this.item);
      if (request.status === 200) {
        this.$router.push({ name: 'companies.view', params: { id: request.data } });
      } else {
        this.errors = request.data.errors;
        this.buttonDisabled = false;
      }
    },
  },
  beforeMount() {
    this.getCompanyOptions();
    this.getCountries();
  }
}

</script>
